import { cn } from "@klarify/ui/lib/utils";
import { CalendarIcon, Search } from "lucide-react";
import type * as React from "react";

export interface InputProps extends React.ComponentProps<"input"> {
	isSearch?: boolean;
	isDatePicker?: boolean;
	autoComplete?: string;
	inputClassName?: string;
	prefixIcon?: React.ReactNode;
	/** When true, drops the `max-w-80` cap baked into `isSearch`. */
	noMaxWidth?: boolean;
}

const Input = ({
	ref,
	className,
	type,
	isDatePicker,
	isSearch,
	autoComplete,
	inputClassName,
	prefixIcon,
	noMaxWidth,
	...props
}: InputProps) => {
	return (
		<div className={cn("relative flex w-full items-center", className)}>
			{(prefixIcon ?? isSearch) && (
				<div className="absolute left-4 flex items-center">
					{prefixIcon ?? (
						<Search
							className="text-klarify-neutral-700"
							size={16}
						/>
					)}
				</div>
			)}

			<input
				type={type}
				className={cn(
					"flex h-9 w-full rounded-md border border-klarify-neutral-200 bg-white px-4 py-3 font-normal text-klarify-neutral-800 text-sm transition-colors file:bg-transparent file:text-sm placeholder:text-muted-foreground focus:ring-primary focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-50",
					isSearch &&
						"h-11 w-full max-w-80 pl-10 font-normal text-klarify-neutral-500 text-sm tracking-normal placeholder:text-klarify-neutral-500 focus:ring-0 focus-visible:ring-0",
					isSearch && noMaxWidth && "max-w-none",
					!isSearch && "pl-3",
					inputClassName,
					prefixIcon && "pl-10",
				)}
				autoComplete={autoComplete ?? "off"}
				ref={ref}
				{...props}
			/>
			{isDatePicker && (
				<CalendarIcon className="absolute right-4 h-4 w-4 text-klarify-gray-mod-400" />
			)}
		</div>
	);
};

Input.displayName = "Input";

export { Input };
